import type { ModuleLanguage } from "../../contract";

const catalog = {
  de: {
    previewQuestion: "Welche Stadt liegt an der Spree?",
    previewOptions: ["Berlin", "Bonn", "Bremen", "Dresden"],
    questionProgress: (current: number, total: number) => `Frage ${String(current)} von ${String(total)}`,
    remaining: (time: string) => `Noch ${time}`,
    paused: (time: string | null) => time === null ? "Pausiert" : `Pausiert · ${time}`,
    correct: "Richtig",
    answerCount: (count: number) => `${String(count)} Antworten`,
    percentage: (percent: number) => `${String(percent)} %`,
    results: "Quiz-Ergebnis",
    correctAnswers: (count: number) => `${String(count)} richtig`,
    noParticipants: "Noch keine Antworten",
    editorLabel: "Quiz",
    editorDescription: "Quizfrage, Antwortverteilung und Rangliste im Overlay.",
    editorModuleLabel: "Quiz",
    showQuestionProgress: "Fragenfortschritt anzeigen",
    showPercent: "Prozentwerte anzeigen",
    backgroundColor: "Hintergrundfarbe",
    textColor: "Textfarbe",
    secondaryColor: "Sekundärfarbe",
    accentColor: "Akzentfarbe",
    correctColor: "Farbe der richtigen Antwort",
  },
  en: {
    previewQuestion: "Which city sits on the Spree?",
    previewOptions: ["Berlin", "Bonn", "Bremen", "Dresden"],
    questionProgress: (current: number, total: number) => `Question ${String(current)} of ${String(total)}`,
    remaining: (time: string) => `${time} remaining`,
    paused: (time: string | null) => time === null ? "Paused" : `Paused · ${time}`,
    correct: "Correct",
    answerCount: (count: number) => `${String(count)} answers`,
    percentage: (percent: number) => `${String(percent)}%`,
    results: "Quiz results",
    correctAnswers: (count: number) => `${String(count)} correct`,
    noParticipants: "No answers yet",
    editorLabel: "Quiz",
    editorDescription: "Quiz question, answer distribution, and ranking in the overlay.",
    editorModuleLabel: "Quiz",
    showQuestionProgress: "Show question progress",
    showPercent: "Show percentages",
    backgroundColor: "Background colour",
    textColor: "Text colour",
    secondaryColor: "Secondary colour",
    accentColor: "Accent colour",
    correctColor: "Correct answer colour",
  },
} as const;

export const quizOverlayTexts = (language: ModuleLanguage) => catalog[language];
